import { render, staticRenderFns } from "./crt-overlay.vue?vue&type=template&id=042f4694&scoped=true&"
import script from "./crt-overlay.vue?vue&type=script&lang=js&"
export * from "./crt-overlay.vue?vue&type=script&lang=js&"
import style0 from "./crt-overlay.vue?vue&type=style&index=0&id=042f4694&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042f4694",
  null
  
)

export default component.exports